import { type EncoderData, type PrintDataRecords } from "./parseBin";

const HALF_WINDOW_MICROSECONDS = 2_500_000;

// Homing can temporarily invalidate encoder referencing.
export const MAX_ENCODER_ERROR_MM = 25;
export const isUsableEncoderError = (value: number) =>
  Number.isFinite(value) && Math.abs(value) <= MAX_ENCODER_ERROR_MM;

/**
 * Subtract a centered five-second sample mean to remove slow variations.
 * Use timestamps rather than a fixed sample count. At the recording edges,
 * use the available part of the window; invalid samples do not enter the mean.
 * Sliding window pointers keep preprocessing linear for long recordings.
 */
export function encoderMovingAverage(
  records: PrintDataRecords<EncoderData>,
  axis: "xError" | "yError"
): Float64Array {
  const baseline = new Float64Array(records.length);
  let start = 0;
  let end = 0;
  let sum = 0;
  let count = 0;
  for (let i = 0; i < records.length; i++) {
    const timestamp = records.at(i).timestamp;
    while (
      end < records.length &&
      records.at(end).timestamp <= timestamp + HALF_WINDOW_MICROSECONDS
    ) {
      const value = records.at(end)[axis];
      if (isUsableEncoderError(value)) {
        sum += value;
        count++;
      }
      end++;
    }
    while (
      start < end &&
      records.at(start).timestamp < timestamp - HALF_WINDOW_MICROSECONDS
    ) {
      const value = records.at(start)[axis];
      if (isUsableEncoderError(value)) {
        sum -= value;
        count--;
      }
      start++;
    }
    baseline[i] = count > 0 ? sum / count : 0;
  }
  return baseline;
}
